module.exports = __webpack_public_path__ + "media/images/flags/32/Japan-08c190eda96bfcf811ad1ba67409ad8d.png";